// Individual modules
var bravo = bravo || {};
var crh = crh || {};
bravo.utilities = (function () {
	'use strict';

	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	var debounce = function (func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) {
					func.apply(context, args);
				}
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) {
				func.apply(context, args);
			}
		};
	};

	var keepDropdownOpen = function () {
		jQuery('.js-keep-open').on('click', function (e) {
			e.stopPropagation();
		});
	};

	var carouselTouch = function () {
		var touchStartX = null;

		$('.carousel').each(function () {
			var $carousel = $(this);
			$(this)
				.on('touchstart', function (event) {
					var e = event.originalEvent;
					if (e.touches.length === 1) {
						var touch = e.touches[0];
						touchStartX = touch.pageX;
					}
				})
				.on('touchmove', function (event) {
					var e = event.originalEvent;
					if (touchStartX !== null) {
						var touchCurrentX = e.changedTouches[0].pageX;
						if (touchCurrentX - touchStartX > 60) {
							touchStartX = null;
							$carousel.carousel('prev');
						} else if (touchStartX - touchCurrentX > 60) {
							touchStartX = null;
							$carousel.carousel('next');
						}
					}
				})
				.on('touchend', function () {
					touchStartX = null;
				});
		});
	};

	var setCookie = function (name, value, daysFromNow) {
		var expires = '';
		if (daysFromNow) {
			var date = new Date();
			date.setTime(date.getTime() + daysFromNow * 24 * 60 * 60 * 1000);
			expires = 'expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + '; ' + expires + '; path=/';
	};

	return {
		debounce: debounce,
		keepDropdownOpen: keepDropdownOpen,
		carouselTouch: carouselTouch,
		setCookie: setCookie
	};
})();
bravo.tracking = (function () {
	'use strict';

	// for TNEW
	const getTNEWDataObjects = () => {
		// seems that referencing them as simple vars at the top of the bravo.tracking function will return 'undefined'
		const sessionObj = window.dataLayer?.find((item) => item.session)?.session || {};
		const productObj = window.dataLayer?.find((item) => item.product)?.product || {};
		const orderObj = window.dataLayer?.find((item) => item.transactionId) || {};

		return { sessionObj, productObj, orderObj };
	};

	// to listen for TNEW requests, we can use the new 'performance' API to check for a successful response. Neat
	const listenForRequests = (urlEndpoints = [], successCallback) => {
		let checkInterval;

		const checkSuccess = () => {
			const performanceEntries = window.performance.getEntriesByType('resource');
			const successEntry = performanceEntries.some((entry) =>
				urlEndpoints.some((urlEndpoint) => entry.name.includes(urlEndpoint) && entry.responseEnd > 0)
			);
			if (successEntry) {
				clearInterval(checkInterval);
				successCallback();
			}
		};

		checkInterval = setInterval(checkSuccess, 500);
	};

	const tnewEventDetailTracking = () => {
		const cartSuccessCallback = () => {
			window.dataLayer = window.dataLayer || [];
			const { productObj } = getTNEWDataObjects();

			const transactionTotal =
				Number(
					document.querySelector('.tn-syos-mobile-cart-controls__summary-subtotal')?.textContent.replace('$', '')
				) || undefined;
			const productionSeasonId = productObj?.productionSeasonId;
			const productionName = document.querySelector('.tn-prod-season-header__title')?.textContent;

			const syosSelectors = {
				price: document.querySelector('.tn-ticket-selector__fixed-amount-input'),
				quantity: document.querySelector('.tn-ticket-selector__pricetype-select')
			};
			const nonSyosSelectors = {
				price: document.querySelector('.tn-syos-mobile-cart-controls__summary-subtotal'),
				quantity: document.querySelector('.tn-syos-mobile-cart-controls__summary-seat-count')
			};

			// am accounting for page layout that has an SYOS, and page layout that doesn't have an SYOS...
			const price = syosSelectors.price?.value
				? Number(syosSelectors.price.value.replace('$', ''))
				: nonSyosSelectors.price
				? Number(nonSyosSelectors.price.textContent.replace('$', ''))
				: undefined;
			const quantity = syosSelectors.quantity?.value
				? Number(syosSelectors.quantity.value)
				: nonSyosSelectors.quantity
				? Number(nonSyosSelectors.quantity.textContent.split(' ')?.[0])
				: undefined;

			const trackingObj = {
				event: 'addToCart',
				transcationId: undefined,
				transactionShipping: undefined,
				transactionTotal,
				transactionTax: undefined,
				transactionProducts: [
					{
						sku: `${productObj?.performanceId}|undefined|undefined|undefined`,
						name: `${productionSeasonId}|${productionName}`,
						category: undefined,
						price,
						quantity
					}
				]
			};

			window.dataLayer.push(trackingObj);
		};

		listenForRequests(['api/syos/ReserveTempCartSeats', 'api/tickets/reservation'], cartSuccessCallback);
	};

	return {
		tnewEventDetailTracking
	};
})();
bravo.present = (function () {
	'use strict';

	var currentPage = 2; // Start from page 2 since page 1 is already loaded
	var pageSize = window.CRHPresentsPagingSize || 12;
	var isLoading = false;

	var renderEventCard = function (event, columnClass) {
		var imageHtml = '';
		if (event.image && event.image.crops) {
			// Find the crop with alias "small-5-3"
			var smallCrop = event.image.crops.find(function (crop) {
				return crop.alias === 'small-5-3';
			});

			if (smallCrop && event.image.url) {
				// Build the image URL using the URL API to preserve existing parameters (e.g. versioning)
				var imageUrlObject = new URL(event.image.url, window.location.origin);
				var searchParams = imageUrlObject.searchParams;

				// Set width and height
				searchParams.set('width', smallCrop.width);
				searchParams.set('height', smallCrop.height);

				// Add focal point if it exists
				if (event.image.focalPoint && event.image.focalPoint.left !== null && event.image.focalPoint.top !== null) {
					searchParams.set('rxy', event.image.focalPoint.left + ',' + event.image.focalPoint.top);
				} else {
					searchParams.delete('rxy');
				}

				// Build the new image URL with all parameters
				var imageUrl = imageUrlObject.toString();

				imageHtml =
					'<a href="' +
					event.url +
					'">' +
					'<img class="img-fluid" src="' +
					imageUrl +
					'" loading="lazy" alt="' +
					event.title +
					'" />' +
					'</a>';
			}
		}

		return (
			'<div class="' +
			columnClass +
			'">' +
			'<div class="event-card">' +
			imageHtml +
			'<h3 class="card-title">' +
			event.title +
			'</h3>' +
			'<p>' +
			event.dateRangeCaption +
			'</p>' +
			'<div class="btn-rte-link button-container">' +
			'<a class="btn btn-secondary mt-3" href="' +
			event.url +
			'">More Info</a>' +
			'</div>' +
			'</div>' +
			'</div>'
		);
	};

	var renderEvents = function (events) {
		var $loadMoreContent = $('#load-more-content');
		var html = '';

		// Group events into pairs for the 2-column layout
		for (var i = 0; i < events.length; i += 2) {
			var firstEvent = events[i];
			var secondEvent = events[i + 1];

			html += '<div class="row clearfix">';

			// First event
			html += renderEventCard(firstEvent, 'col-md-6 column mb-5');

			// Second event (if exists)
			if (secondEvent) {
				html += renderEventCard(secondEvent, 'col-md-6 column mb-5');
			}

			html += '</div>';
		}

		$loadMoreContent.append(html);
	};

	var loadMoreEvents = function () {
		if (isLoading) {
			return;
		}

		isLoading = true;
		var $loadMoreBtn = $('#load-more-btn');

		// Show loading state
		$loadMoreBtn.prop('disabled', true).text('Loading...');

		// Make API call
		$.ajax({
			url: '/Umbraco/Api/CRHpresentsApi/GetPastEvents',
			method: 'GET',
			data: {
				page: currentPage,
				pageSize: pageSize
			},
			success: function (response) {
				if (response && response.items && response.items.length > 0) {
					// Render the new events
					renderEvents(response.items);

					// Check if there are more pages
					if (response.paging && response.paging.hasNextPage) {
						currentPage++;
						$loadMoreBtn.prop('disabled', false).text('load more ...');
					} else {
						// No more events, hide the button
						$loadMoreBtn.closest('div').hide();
					}
				} else {
					// No more events, hide the button
					$loadMoreBtn.closest('div').hide();
				}
			},
			error: function (xhr, status, error) {
				console.error('Error loading more events:', error);
				$loadMoreBtn.prop('disabled', false).text('load more ...');
			},
			complete: function () {
				isLoading = false;
			}
		});
	};

	var initLoadMore = function () {
		var $loadMoreBtn = $('#load-more-btn');

		if ($loadMoreBtn.length === 0) {
			return; // No load more button found
		}

		$loadMoreBtn.on('click', function (e) {
			e.preventDefault();

			if (isLoading) {
				return; // Prevent multiple simultaneous requests
			}

			loadMoreEvents();
		});
	};

	var init = function () {
		initLoadMore();
	};

	return {
		init: init
	};
})();

//https://codepen.io/wallaceerick/pen/ctsCz
$('.custom-select').each(function () {
	'use strict';

	var $this = $(this),
		numberOfOptions = $(this).children('option').length;

	$this.addClass('select-hidden');
	$this.wrap('<div class="select"></div>');
	$this.after('<div class="select-styled"><span></span></div>');

	var $styledSelect = $this.next('div.select-styled');
	$styledSelect.text($this.children('option').eq(0).text());

	var $list = $('<ul />', {
		class: 'select-options'
	}).insertAfter($styledSelect);

	for (var i = 0; i < numberOfOptions; i++) {
		$('<li />', {
			text: $this.children('option').eq(i).text(),
			rel: $this.children('option').eq(i).val(),
			'data-href': $this.children('option').eq(i).data('href')
		}).appendTo($list);
	}

	var $listItems = $list.children('li');
	$this.parent().parent().next().attr('href', $listItems[1].getAttribute('data-href'));

	$styledSelect.click(function (e) {
		e.stopPropagation();
		$('div.select-styled.active')
			.not(this)
			.each(function () {
				$(this).removeClass('active').next('ul.select-options').hide();
			});
		$(this).toggleClass('active').next('ul.select-options').toggle();
	});

	$listItems.click(function (e) {
		e.stopPropagation();
		$styledSelect.text($(this).text()).removeClass('active');
		$this.val($(this).attr('rel'));
		$list.hide();

		$this.parent().parent().next().attr('href', $(this).data('href')).removeClass('d-none');
	});

	$this.on('change', function () {
		$styledSelect.text(this.value).removeClass('active');
	});

	$(document).click(function () {
		$styledSelect.removeClass('active');
		$list.hide();
	});
});

crh.firstVisitBanner = (function () {
	'use strict';

	var COOKIE_NAME = 'first_visit_banner_dismissed';
	var COOKIE_DAYS = 365;

	var banner = document.querySelector('#first-visit-banner');

	var setDismissedCookie = function () {
		bravo.utilities.setCookie(COOKIE_NAME, 'true', COOKIE_DAYS);
	};

	var slideAway = function () {
		setDismissedCookie();
		banner.addEventListener(
			'transitionend',
			function () {
				banner.remove();
			},
			{ once: true }
		);
		banner.classList.add('is-hidden');
	};

	var init = function () {
		if (!banner) return;

		// If the banner has already been dismissed, remove it and stop.
		// _FirstVisitBanner.cshtml doesn't render the banner once the cookie exists, but pressing Back can make the browser reuse the HTML it loaded before the cookie was set. This is to make sure that it's not shown again if the user goes back to the page.
		if (document.cookie.indexOf(COOKIE_NAME + '=') !== -1) {
			banner.remove();
			return;
		}

		banner.querySelectorAll('.js-first-visit-banner-dismiss').forEach(function (button) {
			button.addEventListener('click', slideAway);
		});

		// Following a link in the content also dismisses the banner.
		// It's removed instantly rather than slid away, because sliding it while the next page loads shows as a jump.
		banner.addEventListener('click', function (e) {
			if (!e.target.closest('.first-visit-banner-content a[href]')) return;

			setDismissedCookie();
			banner.remove();
		});
	};

	return {
		init: init
	};
})();
crh.header = (function () {
	'use strict';

	var setAbsoluteHeaderTop = function ($header) {
		var $body = $('body');
		if ($body.hasClass('has-prompt') && $body.hasClass('has-global-banner')) {
			$header.css('top', 'calc(var(--prompt-height) + var(--global-banner-height))');
		} else if ($body.hasClass('has-prompt')) {
			$header.css('top', 'var(--prompt-height)');
		} else if ($body.hasClass('has-global-banner')) {
			$header.css('top', 'var(--global-banner-height)');
		} else {
			$header.css('top', '0');
		}
	};

	var initialize = function () {
		// Set initial position before any scroll events
		var $header = $('.site-header');
		var $window = $(window);

		// Set initial position based on scroll position
		if ($window.scrollTop() > $header.outerHeight()) {
			$header.addClass('js-nav-up');
			$header.removeClass('js-absolute-header');
		} else {
			$header.removeClass('js-nav-up');
			$header.addClass('js-absolute-header');
			setAbsoluteHeaderTop($header);
		}

		this.toggleHeader();
	};

	var toggleHeader = function () {
		var $window = $(window),
			$header = $('.site-header'),
			didScroll = false,
			lastScrollTop = 0,
			delta = 5,
			navbarHeight = $header.outerHeight(),
			scrollTop,
			switchAbsoluteOn;

		function headerOnOff() {
			scrollTop = $window.scrollTop();

			// Calculate switch point based on viewport height
			switchAbsoluteOn = Math.min($window.height(), 400);

			if (scrollTop >= switchAbsoluteOn) {
				$header.removeClass('js-absolute-header');
				// $header.css('top', '0');
			} else {
				$header.addClass('js-absolute-header');
				setAbsoluteHeaderTop($header);
			}
		}

		function hasScrolled() {
			var st = $window.scrollTop();

			// Make sure they scroll more than delta
			if (Math.abs(lastScrollTop - st) <= delta) {
				return;
			}

			// If we're at the top of the page, ensure header is in absolute position
			if (st <= navbarHeight) {
				$header.addClass('js-absolute-header');
				$header.removeClass('js-nav-up');
				setAbsoluteHeaderTop($header);
				lastScrollTop = st;
				return;
			}

			if (st > lastScrollTop && st > navbarHeight) {
				// Scroll Down - Always stick to top: 0
				$header.addClass('js-nav-up');
				$header.removeClass('js-absolute-header');
			} else {
				// Scroll Up
				$header.removeClass('js-nav-up');
				setAbsoluteHeaderTop($header);
			}

			lastScrollTop = st;
		}

		// Initial setup
		headerOnOff();

		$window.scroll(function () {
			didScroll = true;
		});

		setInterval(function () {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		// Handle mobile dropdown
		$('.nav-dropdown').on('show.bs.dropdown', function () {
			$header.addClass('js-black-header');
			$('body').addClass('sm-lock-scroll');
		});

		$('.nav-dropdown').on('hide.bs.dropdown', function () {
			$header.removeClass('js-black-header');
			$('#searchDropdownMenu').not('.show').length && $('body').removeClass('sm-lock-scroll');
		});

		// Handle accordion toggles
		$('.js-toggle-accordion').on('click', function (e) {
			e.stopPropagation();
			$(this).next().collapse('toggle');

			if ($(this).parent().hasClass('expanded')) {
				$(this).parent().removeClass('expanded');
			} else {
				$('.expanded').removeClass('expanded');
				$(this).parent().addClass('expanded');
			}
		});

		// Close expanded sub menu on desktop
		$(document).on('click', function () {
			$('.js-toggle-accordion').next().collapse('hide');
			$('.expanded').removeClass('expanded');
		});
	};

	return {
		init: initialize,
		toggleHeader: toggleHeader
	};
})();
crh.prompt = (function () {
	'use strict';

	var prompt = document.querySelector('#prompt');

	var setCssVarPromptHeight = () => {
		if (!prompt) return;
		var promptHeight = prompt.clientHeight || 0;
		document.documentElement.style.setProperty('--prompt-height', promptHeight + 'px');
	};

	var init = () => {
		if (!prompt) return;

		// Set initial height before showing prompt
		setCssVarPromptHeight();

		// Add resize listener
		window.addEventListener('resize', setCssVarPromptHeight);

		// Handle close button
		prompt.querySelector('#prompt-close').addEventListener('click', () => {
			document.body.classList.remove('has-prompt');
			var promptTitle = prompt.querySelector('#prompt-title');
			var daysToAdd = parseInt(promptTitle.dataset.expiry);

			document.documentElement.style.setProperty('--prompt-height', '0px');
			bravo.utilities.setCookie('is_prompt_closed', encodeURIComponent(promptTitle.textContent), daysToAdd);
		});
	};

	return {
		init
	};
})();
crh.globalMessaging = (function () {
	'use strict';

	var banner = document.querySelector('#global-messaging-banner');

	var setCssVarGlobalBannerHeight = function () {
		if (!banner) return;
		var bannerHeight = banner.clientHeight || 0;
		document.documentElement.style.setProperty('--global-banner-height', bannerHeight + 'px');
	};

	var init = function () {
		if (!banner) return;

		setCssVarGlobalBannerHeight();
		window.addEventListener('resize', setCssVarGlobalBannerHeight);
	};

	return {
		init: init
	};
})();
crh.search = (function () {
	'use strict';

	var baseUrl = '';

	var initialize = function () {
		baseUrl = $('#searchDropdownMenu').data('base-url');
		this.handleSearchDropdown();
		this.auto();
	};

	//this needs to be used to avoid stopPropagation bugs
	var handleSearchDropdown = function () {
		$('#searchDropdown').on('click', function () {
			var $this = $(this);
			$this.parent().toggleClass('show');

			if ($('#searchDropdownMenu').hasClass('show')) {
				$this.attr('aria-expanded', true);
				$('body').addClass('sm-lock-scroll');
				$('.nav-utils, .nav-dropdown').addClass('muted');
				$('#searchDropdownMenu input[name=keywords]').focus();
			} else {
				$this.attr('aria-expanded', false);
				$('body').removeClass('sm-lock-scroll');
				$('.nav-utils, .nav-dropdown').removeClass('muted');
			}
		});

		$('body').on('click', function (e) {
			if (
				!$('#searchDropdownMenu').is(e.target) &&
				$('#searchDropdownMenu').has(e.target).length === 0 &&
				$('.show').has(e.target).length === 0
			) {
				$('#searchDropdownMenu').removeClass('show');
				$('.nav-utils, .nav-dropdown').removeClass('muted');
			}
		});
	};

	var autocomplete = function () {
		//hide autocomplete on click outside
		var hideOnClickOutside = function (selector) {
			var outsideClickListener = function (event) {
				var $target = $(event.target);
				if (!$target.closest(selector).length && $(selector).is(':visible')) {
					$(selector).removeClass('active');
					$(selector)[0].innerHTML = '';
				}
			};

			$(document).on('click', outsideClickListener);
		};

		var search = function (e) {
			var keywords = e.target.value;
			var currentValue = this.value;
			var matched = [];
			var autocompleteString = '';
			var response;
			//we want to activate only the nearest autocomplete container
			var autocompleteContainer = $(this).next('.js-autocomplete');

			if (currentValue) {
				//this is where we can do the ajax call,
				//where data will be the json response - an array of objects that include an id, title and url
				//will need to implement a stricter match or we can limit the number of autocompletes.
				$.get(baseUrl + '/umbraco/Api/SearchApi/AutoCompleteSearch?keywords=' + keywords)
					.done(function (res) {
						response = res.results;
						autocompleteContainer.addClass('active');
						matched = response;
						matched.forEach(function (match) {
							autocompleteString += '<button role="tab" data-link=' + match.url + '>' + match.title + '</button>';
						});

						autocompleteContainer[0].innerHTML = autocompleteString;
					})
					.fail(function (err) {
						console.log('Error', err);
					});
			} else {
				autocompleteContainer[0].innerHTML = '';
			}
		};

		var initiateSearch = function (event) {
			event.preventDefault();

			var selectedQuery = event.currentTarget.value;

			var queryObj = {
				keywords: selectedQuery
			};

			window.location.href = baseUrl + '/search-results/?' + $.param(queryObj);
		};

		var initiatePage = function (event) {
			event.preventDefault();
			window.location.href = event.target.dataset.link;
		};

		hideOnClickOutside('.js-autocomplete');

		$('.js-search').on('input', bravo.utilities.debounce(search, 250));

		//click on an autocomplete query will search, might need a cleanup
		$('.js-autocomplete').on('click', 'button', initiatePage);
		$('.js-search').on('keypress', function (e) {
			if (e.key === 'Enter') {
				initiateSearch(e);
			}
		});
		$('.search-button').on('click', initiateSearch);
	};

	return {
		init: initialize,
		auto: autocomplete,
		handleSearchDropdown: handleSearchDropdown
	};
})();
crh.memberEvents = (function() {
    'use strict';

    Swag.registerHelpers(Handlebars);

    var $container = $('.js-event-grid'),
        source = $('#tile-template'),
        $loading = $('.content-loading'),
        template,
        eventPickerList = [];

    let monthsShort = pickmeup.defaults.locales.en.monthsShort;
    let months = pickmeup.defaults.locales.en.months;
    let weekdays = pickmeup.defaults.locales.en.daysShort;
    // console.log(monthsShort, weekdays);

    if (source.length > 0) {
        source = source.html().trim();
        template = Handlebars.compile(source);
    }

    var getEventPickerList = () => {
        return eventPickerList;
    };

    var renderTiles = function(items, resetContainer) {
        var newTiles = '';

        $.each(items, function(i, v) {
            var shortDesc = v.allValues.tileIntro != null ? v.allValues.tileIntro : '';

            //var tileClasses = 'tile';

            var newItem = {
                id: v.allValues.id,
                url: v.allValues.url !== null ? v.allValues.url : '#',
                //tileType: v.Type.toLowerCase(),
                //tileClasses: tileClasses,
                label: '', //'tickets selling fast!', //v.Label,
                name: v.allValues.eventName ? v.allValues.eventName : v.allValues.nodeName,
                //artist: v.EventArtist,
                //status: v.EventStatus,
                genre: v.allValues.genre,
                presenter: v.allValues.presenter,
                date: v.allValues.dateRangeCaption,
                shortDescription: shortDesc,
                image1440: v.allValues.imageTileLarge ? v.allValues.imageTileLarge : null,
                image1024: v.allValues.imageTileSmall ? v.allValues.imageTileSmall : null,
                image: v.allValues.imageTile ? v.allValues.imageTile : null,
                imageAlt: v.allValues.imageTileAlt ? v.allValues.imageTileAlt : '',
                //image: v.BannerImage
            };

            //if (v.BannerImage != null) {
            //	newItem.image = v.BannerImage;
            //}

            newTiles += template(newItem);
        });

        var $newItems = $(newTiles);

        if (resetContainer) {
            $container
                .isotope({
                    layoutMode: 'fitRows',
                    percentPosition: true,
                    itemSelector: '.grid-item'
                })
                .isotope('remove', $container.children())
                .isotope('insert', $newItems);

            $container.imagesLoaded(function() {
                window.setTimeout(function() {
                    $container.isotope('layout').isotope('on', 'layoutComplete', updateAfterLayoutComplete());
                }, 300);
            });
        } else {
            if (items.length > 0) {
                $container
                    .isotope({
                        layoutMode: 'fitRows',
                        percentPosition: true,
                        itemSelector: '.grid-item'
                    })
                    .append($newItems)
                    .isotope('appended', $newItems);

                $container.imagesLoaded(function() {
                    //window.setTimeout(function() {
                    $container.isotope('layout').isotope('on', 'layoutComplete', updateAfterLayoutComplete());
                    //}, 2000);
                });
            } else {
                //Note: On first load there are no items at all
                updateAfterLayoutComplete();
            }
        }

        //temp. change to rearrange on images load
        // window.setTimeout(function() {
        //     $container.isotope('layout');
        // }, 2000);
    };

    //private
    function addActive() {
        $('.fav-events-count').addClass('active');
    }

    var currentFavourites = function() {
        var favCookies = Cookies.get('crh-favs');
        var favs = [];

        if (favCookies !== undefined && favCookies !== '') {
            favs = JSON.parse(favCookies);
        }
        return favs;
    };

    function updateEventsCount() {
        if (currentFavourites().length > 0) {
            $('.fav-events-count').text(currentFavourites().length);
        } else {
            $('.fav-events-count').removeClass('active');
        }
    }

    function checkCookie() {
        if (currentFavourites().length > 0) {
            addActive();
            updateEventsCount();

            $.each(currentFavourites(), function(k, v) {
                $('.js-toggle-favourite[data-favourite=' + v + ']')
                    .addClass('active')
                    .attr('aria-label', 'Remove from Favourites')
                    .attr('title', 'Remove?')
                    .find('.sr-only')
                    .text('Remove from Favourites');
            });
        }
    }

    function updateAfterLayoutComplete() {
        $loading.fadeOut(250);
        $container.removeClass('items-loading');
        picturefill();
        checkCookie();

        $('[data-toggle="tooltip"]').tooltip();
    }

    function eventDetailFavourite() {
        var id = $('.btn-event-fav').data('favourite');

        var favs = currentFavourites();

        var found = favs.find(function(el) {
            if (el === id) {
                $('.btn-event-fav')
                    .addClass('active')
                    .attr('aria-label', 'Remove from Favourites')
                    .find('.sr-only')
                    .text('Remove from Favourites');
            }
        });
    }

    var eventAdded = function(eventId) {
        var favs = currentFavourites();
        return $.inArray(eventId, favs) !== -1;
    };

    var updateMessage = function(eventId) {
        var eventName = $('.js-toggle-favourite[data-favourite=' + eventId + ']').data('event-title');

        var found = eventAdded(eventId);

        if (found) {
            console.log(eventName + ' has been added to your favourites');
        } else {
            console.log(eventName + ' has been removed from your favourites');
        }
    };

    var addFavToCookie = function(eventId) {
        var favs = currentFavourites();
        favs.push(eventId);
        Cookies.set('crh-favs', favs);
        updateEventsCount();
        updateMessage(eventId);
    };

    var removeFavFromCookie = function(eventId) {
        var favs = currentFavourites();
        var index = favs.indexOf(eventId);
        favs.splice(index, 1);
        Cookies.set('crh-favs', favs, { expires: 365, path: '/' });
        updateEventsCount();
        updateMessage(eventId);
    };

    var initialize = function() {
        $('.js-init-fav-button').on('click', '.js-toggle-favourite', function() {
            var $this = $(this);

            $this.toggleClass('active');

            if ($this.attr('aria-label') === 'Add to favourites') {
                $this
                    .attr('aria-label', 'Remove from favourites')
                    .find('.sr-only')
                    .text('Remove from Favourites');

                $this.tooltip('dispose');
                $this.attr('title', 'Remove?').tooltip();
            } else {
                $this
                    .attr('aria-label', 'Add to favourites')
                    .find('.sr-only')
                    .text('Add to Favourites');

                $this.tooltip('dispose');
                $this.attr('title', 'Add to Favourites').tooltip();
            }

            var eventId = $this.data('favourite');
            var eventName = $this.data('event-title');

            eventAdded(eventId) ? removeFavFromCookie(eventId) : addFavToCookie(eventId);

            checkCookie();
        });

        checkCookie();

        eventDetailFavourite();
    };

    return {
        init: initialize,
        currentFavourites: currentFavourites,
        renderTiles: renderTiles,
        getEventPickerList: getEventPickerList
    };
})();
crh.filters = (function () {
	'use strict';

	var filterDates = [],
		filterGenre = [],
		filterRange = '',
		isOpenEnded = false,
		page = 1,
		defaultFirstPage = 1,
		defaultPageSize = 12,
		refreshedPage = true,
		filterDatesAPIString = '',
		$container = $('.js-event-grid'),
		$loading = $('.content-loading'),
		$genreFilterContainer = $('.genre-swiper-container .swiper-wrapper'),
		$genreFilterList = $('.filtered-genres'),
		$loadMoreBtn = $('.js-load-more'),
		$clearFiltersBtn = $('.js-btn-clear');

	//ie11 fix for searchParams
	$.urlParam = function (name) {
		var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
		if (results === null) {
			return null;
		} else {
			return decodeURI(results[1]) || 0;
		}
	};

	const showClearFilter = function () {
		window.location.search ? $clearFiltersBtn.show() : $clearFiltersBtn.hide();
	};

	function removeFilter(el, list) {
		for (var i = list.length - 1; i >= 0; i--) {
			if (list[i] === el.val()) {
				list.splice(i, 1);
				break;
			}
		}
	}

	var buildFilterQuery = function (filterDates, filterGenre, filterRange, page) {
		var qs = [];

		if (filterGenre.length > 0) {
			qs.push('genres=' + filterGenre);
		}

		if (filterRange && filterRange.length > 0) {
			qs.push('range=' + filterRange);
		}

		if (filterDates.length > 0) {
			qs.push('dates=' + filterDates);
		}

		if (page > 1) {
			qs.push('page=' + page);
		}
		return qs.length > 0 ? '?' + qs.join('&') : '';
	};

	var setActiveState = function () {
		if (filterRange) {
			var $activeButton = $('.quick-filters').find(`[data-date-range='${filterRange}']`);
			$activeButton.addClass('active').parent().attr('aria-selected', 'true');

			// set isOpenEnded based on the active button's data attribute
			if ($activeButton.length) {
				isOpenEnded = $activeButton.data('open-ended') === true || $activeButton.data('open-ended') === 'true';
			}
		}
	};

	var clearActiveState = function () {
		$('.js-range').removeClass('active');
		$('.js-range').parent().attr('aria-selected', 'false');
		pickmeup('.datepicker').clear();
		$('.filtered-dates').text('');
		isOpenEnded = false;
		// $('.pmu-selected').removeClass('pmu-selected');
	};

	var getParamsFromUrl = function () {
		var datesParam = $.urlParam('dates');
		var genreParam = $.urlParam('genres');
		var rangeParam = $.urlParam('range');
		var pageParam = $.urlParam('page');

		if (datesParam) {
			filterDatesAPIString = datesParam.split(',');
		}

		if (pageParam) {
			page = parseInt(pageParam);
		}

		if (genreParam) {
			filterGenre = genreParam.split(',');

			$.each(filterGenre, function (i, v) {
				let $input = $('input[value=' + v + ']');
				$input.prop('checked', true);
				let text = $input.next().find('span').text();
				$genreFilterList.append(`<li>${text}</li>`);
			});
		}

		if (rangeParam) {
			filterRange = rangeParam;
		}

		var isOpenEndedParam = $.urlParam('isOpenEnded');
		if (isOpenEndedParam !== null) {
			isOpenEnded = isOpenEndedParam === 'true';
		}

		if (datesParam === null && genreParam === null && rangeParam === null) {
			filterRange = 'upcoming';
		}
	};

	var getItems = function (page, disablePushState) {
		$loading.fadeIn(250);
		$container.addClass('items-loading');

		$container.find('.no-events-found').remove();

		var filterQuery = buildFilterQuery(filterDatesAPIString, filterGenre, filterRange, page);

		if (refreshedPage == false && disablePushState != true) {
			window.history.pushState(null, document.title, window.location.pathname + filterQuery);
		}

		showClearFilter();
		//if page is zero then reset value set?
		var reset = page === 1;

		var dataParams = {
			dates: filterDatesAPIString.toString(),
			genres: filterGenre.toString(),
			range: filterRange.toString(),
			page,
			pageSize: defaultPageSize,
			isOpenEnded
		};

		if (refreshedPage === true || disablePushState == true) {
			dataParams.page = defaultFirstPage;
			dataParams.pageSize = page * defaultPageSize;
			reset = true;
		}

		var url = '/umbraco/Api/SearchApi/WhatsOn';

		$.ajax({
			method: 'GET',
			data: dataParams,
			url: url
		})
			.done(function (response) {
				if (response.paging) {
					if (response.paging.hasNextPage === false) {
						$loadMoreBtn.addClass('d-none');
					} else {
						$loadMoreBtn.removeClass('d-none');
						dataParams.page = page + 1;
						$loadMoreBtn.prop('href', crh.GetAllContentItemsFilteredPagedUrl + '?' + $.param(dataParams));
					}
				}

				crh.memberEvents.renderTiles(response.items, reset);

				if (!response.items.length) {
					$container.append(
						'<h3 class="text-center w-100 no-events-found">No events found with your search criteria. Try changing filters.</h3>'
					);
				}
			})
			.fail(function () {
				$container.append('<h3 class="err no-events-found">Could not retrieve events.</h3>');
			})
			.always(function () {});

		refreshedPage = false;
	};

	var initialize = function () {
		if ($(window).width() < 600) {
			var genreTileSwiper = new Swiper('.genre-swiper-container', {
				slidesPerView: 'auto',
				spaceBetween: 5,
				slideClass: 'genre-tile',
				grabCursor: true,
				freeMode: true,
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide'
				}
			});
		}

		//show / hide filters

		$('#collapseDates').on('show.bs.collapse', function () {
			$('#collapseGenres').collapse('hide');
			$('.pmu-today').focus();
		});

		$('#collapseGenres').on('show.bs.collapse', function () {
			$('#collapseDates').collapse('hide');
		});

		$('#collapseGenres').on('shown.bs.collapse', function () {
			if (genreTileSwiper) {
				genreTileSwiper.update();
			}
			$('.swiper-wrapper .genre-tile:nth-child(1)').focus();
		});

		$('body').on('click', function (e) {
			if (!$(e.target).is('#collapseDates')) {
				$('#collapseDates').collapse('hide');
			}

			if (!$('#collapseGenres').is(e.target) && $('#collapseGenres').has(e.target).length === 0) {
				$('#collapseGenres').collapse('hide');
			}
		});

		getParamsFromUrl();

		//initialise datepicker
		var minDate = new Date().toLocaleDateString();

		//Used to init datepicker if there are dateParams
		let filteredDatesArray = [];

		//create an array of date objects
		$.each(filterDatesAPIString, function (i, v) {
			const slash = '/';
			v = v.slice(0, 4) + slash + v.slice(4, 6) + slash + v.slice(6, 8);

			let nd = new Date(v);
			filteredDatesArray.push(nd);

			// if (v === 'today' || v === 'tomorrow') {
			// 	$('input[value=' + v + ']').prop('checked', true);
			// } else {
			//$('button[value=' + v + ']').addClass('active');
			//}
		});

		function getdateFilterString(filterDates) {
			/**
			 * Render date picker selected days:
			 *   OCT 11, 20 NOV 1, 2, 8 DEC 1, 2
			 *
			 * Studio Bravo - 2018-10-11 - Colin Wirt
			 **/
			// record the size of the array
			var numDates = filterDates.length;

			if (numDates > 0) {
				// retrieve the list of month names
				const monthsShort = pickmeup.defaults.locales.en.monthsShort;

				// sort dates before initialising the lastMonth variable
				const sortedFilterDates = filterDates.sort((a, b) => a - b);

				// initialise last month
				let lastMonth =
					sortedFilterDates[0].getFullYear().toString() + (sortedFilterDates[0].getMonth() + 1).toString();

				// start with the first month name: "Oct"
				let dateFilterString = monthsShort[sortedFilterDates[0].getMonth()] + ' ';
				let monthDays = [];

				// loop through each selected day
				sortedFilterDates.map((value, i) => {
					// determine if the month is changing
					let currentMonth = value.getFullYear().toString() + (value.getMonth() + 1).toString();

					let monthIsChanging = lastMonth !== currentMonth;
					let finalLoop = i + 1 === numDates;

					if (monthIsChanging) {
						// the month is changing
						// append last month's days
						dateFilterString += monthDays.join(', ');

						// reset monthDays, add this day to the new month
						// and render the current month: " Nov "
						monthDays = [value.getDate()];
						dateFilterString += ' ' + monthsShort[value.getMonth()] + ' ';

						// if this is also the last day, render the day
						if (finalLoop) {
							dateFilterString += monthDays.join(', ');
						}
					} else if (finalLoop) {
						// this is the last date in the list
						// add this day to the list of days
						monthDays.push(value.getDate());

						// and add the list of days to the string
						dateFilterString += monthDays.join(', ');
					} else {
						// add this day to the list of days
						monthDays.push(value.getDate());
					}

					// record this month do detect if the month has changed for the next loop
					lastMonth = currentMonth;
				});

				// update the dates list on the UI
				// OCT 11, 20 NOV 1, 2, 8 DEC 1, 2
				$('.filtered-dates')[0].innerHTML = dateFilterString;
			}
		}

		//render selected dates text string
		if (filteredDatesArray.length > 0) {
			getdateFilterString(filteredDatesArray);
		}

		//init datepicker
		pickmeup('.datepicker', {
			default_date: false,
			flat: true,
			mode: 'multiple',
			min: minDate,
			date: filteredDatesArray,
			format: 'Ymd', // formatted for Lucene search term
			prev: '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 13L2 7l6-6" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>',
			next: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><path fill="none" stroke="#FFF" stroke-linecap="round" stroke-width="2" d="M1 1l6 6-6 6"/></svg>'
		});

		setActiveState();

		getItems(page);

		$('.datepicker').on('pickmeup-change', function (e) {
			filterDates = e.detail.date;
			filterDatesAPIString = e.detail.formatted_date.join(',');
			filterRange = '';
			isOpenEnded = false;
			$('.js-range').removeClass('active');

			getdateFilterString(filterDates);
			page = defaultFirstPage;
			getItems(defaultFirstPage);
		});

		$genreFilterContainer.on('change', ':checkbox', function () {
			var $this = $(this);
			let title = $this.next().find('span').text();

			if (!$this.prop('checked')) {
				removeFilter($this, filterGenre);
				$genreFilterList.find(`li:contains(${title})`).remove();
			} else {
				filterGenre.push($(this).val());
				$genreFilterList.append(`<li>${title}</li>`);
			}

			page = defaultFirstPage;
			getItems(defaultFirstPage);
		});

		window.addEventListener('popstate', function (e) {
			clearDates();
			clearGenres();
			clearActiveState();
			if (filteredDatesArray.length > 0) {
				getdateFilterString(filteredDatesArray);
			}
			getParamsFromUrl();
			setActiveState();
			getItems(page, true);
		});

		$('.js-range').on('click', function () {
			filterRange = $(this).data('date-range');
			isOpenEnded = $(this).data('open-ended') === true || $(this).data('open-ended') === 'true';
			$('.js-range').removeClass('active');
			$('.js-range').parent().attr('aria-selected', 'false');
			$(this).addClass('active');
			$(this).parent().attr('aria-selected', 'true');
			clearDates();

			getItems(defaultFirstPage);
		});

		$clearFiltersBtn.click(function (e) {
			e.preventDefault();
			clearFilters();
		});

		$loadMoreBtn.click(function (e) {
			e.preventDefault();
			page = parseInt(page) + 1;
			getItems(page);
		});
	};

	const clearDates = function () {
		filterDates = [];
		filterDatesAPIString = '';
		page = defaultFirstPage;
		pickmeup('.datepicker').clear();
		$('.filtered-dates').text('');
		$('.pmu-selected').removeClass('pmu-selected');
	};

	const clearGenres = function () {
		filterGenre = [];
		$genreFilterList.find('li').remove();
		$genreFilterContainer.find('.form-check-input').prop('checked', false);
	};

	const clearFilters = function () {
		clearDates();
		clearGenres();

		filterRange = '';
		isOpenEnded = false;
		$('.js-range').removeClass('active');
		$('.js-range').parent().attr('aria-selected', 'false');
		getItems(defaultFirstPage);
	};

	return {
		init: initialize,
		buildFilterQuery: buildFilterQuery,
		getItems: getItems,
		getParamsFromUrl: getParamsFromUrl,
		clearFilters: clearFilters
	};
})();
'use strict';

var players = []; // players array (to coltrol players individually)

var Videos = (function () {
	// VARIABLES
	var $ = jQuery, // The jquery
		queue = []; // videos queue (once api is ready, transform this into YT player)

	// Constructor
	function Videos() {}

	// METHODS
	// Add elements to queue
	Videos.prototype.add = function ($video) {
		queue.push($video);
	};

	// Load YT API
	Videos.prototype.loadApi = function () {
		// jQuery get script
		$.getScript('//www.youtube.com/iframe_api', function () {
			// once loaded, create the onYouTubeIframeAPIReady function
			window.onYouTubeIframeAPIReady = function () {
				queue.forEach(function ($video) {
					// Create the YT player
					var player = new YT.Player($video.get(0), {
						controls: 1,
						modestbranding: 1,
						color: 'white',
						enablejsapi: 1,
						showinfo: 0,
						rel: 0,
						showsearch: 0,
						videoId: $video.data('id')
					});
					// add to players array
					players.push(player);
				});
			};
		});
	};

	return Videos;
})();

crh.swiper = (function () {
	'use strict';

	var initialize = function () {
		var videos = new Videos();
		$('.js-player').each(function () {
			videos.add($(this));
		});
		videos.loadApi();

		if ($('.mini-tile-swiper-container').length) {
			var miniTileSwiper = new Swiper('.mini-tile-swiper-container', {
				slidesPerView: 'auto',
				spaceBetween: 5,
				slideClass: 'js-tile-slide',
				grabCursor: true,
				freeMode: true,
				watchOverflow: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide'
				}
			});
		}

		if ($('.homepage-swiper-container').length) {
			var homePageSwiper = new Swiper('.homepage-swiper-container', {
				init: false,
				slidesPerView: 1,
				spaceBetween: 0,
				loop: true,
				slideClass: 'carousel-slide',
				autoHeight: false,
				breakpoints: {
					1200: {
						autoHeight: true
					}
				},
				pagination: {
					el: '.carousel-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.carousel-btn-next',
					prevEl: '.carousel-btn-prev'
				},
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide'
				},
				autoplay: {
					delay: 5000
				},
				autoplayDisableOnInteraction: true
			});

			var homepageVideos = [...document.querySelectorAll('.homepage-swiper-container video')];

			homePageSwiper.on('init', function () {
				homepageVideos.forEach((video) => {
					video.addEventListener('play', function () {
						homePageSwiper.autoplay.stop();
					});

					video.addEventListener('ended', function () {
						homePageSwiper.autoplay.start();
						homePageSwiper.slideNext();
					});
				});
			});

			// this seems to run on init as well
			homePageSwiper.on('slideChangeTransitionEnd', function () {
				// grabbing all videos used in the swiper so we can match their src against the current slide's video src
				// if there's a match, play it, or else pause it
				// we do this since swiper is weird when it comes to substituting cloned slides with real ones upon interaction
				// it's too difficult to target via specific indexes, since when there's looping the slide indexes suddenly change upon mouse drag
				var slidesArr = Array.prototype.slice.call(homePageSwiper.slides || []);
				var activeSlide = slidesArr[homePageSwiper.activeIndex];
				var currVideo = activeSlide ? activeSlide.querySelector('video') : null;
				slidesArr.forEach(function (slide) {
					var slideVideo = slide.querySelector('video');
					if (slideVideo) {
						if (currVideo && slideVideo.querySelector('source').src === currVideo.querySelector('source').src) {
							slideVideo.play();
						} else {
							slideVideo.pause();
							slideVideo.currentTime = 0;
						}
					}
				});
			});

			homePageSwiper.init();
		}

		if ($('.carousel-swiper-container').length) {
			var carouselSwiper = new Swiper('.carousel-swiper-container', {
				slidesPerView: 'auto',
				spaceBetween: 0,
				slideClass: 'carousel-slide',
				pagination: {
					el: '.carousel-pagination',
					clickable: true
				},

				navigation: {
					nextEl: '.carousel-btn-next',
					prevEl: '.carousel-btn-prev'
				},

				breakpoints: {
					1024: {
						spaceBetween: 10
					}
				},
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide'
				},
				on: {
					slideChange: function () {
						players.forEach(function (el) {
							if (el.getPlayerState() === 1) {
								el.pauseVideo();
							}
						});
					}
				}
			});
		}

		if ($('.js-play-video')) {
			var btnPlayVideo = $('.js-play-video');

			btnPlayVideo.on('click', function (e) {
				$(this).fadeOut();

				var videoID = $(this).next().find('iframe').data('id');

				players.forEach(function (el) {
					if (el.getVideoData()['video_id'] === videoID) {
						el.playVideo();
					}
				});
			});
		}

		var activeId;

		if ($('.secondary-nav')) {
			var activeItem = $('.secondary-nav .active');
			activeId = $('.secondary-nav li').index(activeItem);
		}

		if ($(window).width() < 1024) {
			if ($('.js-secondary-nav').length) {
				var secondaryNavSwiper = new Swiper('.js-secondary-nav', {
					slidesPerView: 'auto',
					spaceBetween: 5,
					centeredSlides: true,
					noSwiping: true,
					initialSlide: activeId,
					a11y: {
						prevSlideMessage: 'Previous slide',
						nextSlideMessage: 'Next slide'
					}
				});
			}
		}

		if ($(window).width() < 1340) {
			if ($('.js-quick-filters').length) {
				var quickFiltersSwiper = new Swiper('.js-quick-filters', {
					slidesPerView: 'auto',
					spaceBetween: 20,
					noSwiping: true,
					a11y: {
						prevSlideMessage: 'Previous slide',
						nextSlideMessage: 'Next slide'
					}
				});
			}
		}

		if ($('.carousel-ymbii').length) {
			var ymbiiSwiper = new Swiper('.carousel-ymbii', {
				slidesPerView: 3,
				spaceBetween: 10,
				slideClass: 'carousel-slide',

				pagination: {
					el: '.carousel-pagination',
					clickable: true
				},

				breakpoints: {
					1023: {
						slidesPerView: 2
					},
					600: {
						slidesPerView: 1
					}
				},
				a11y: {
					prevSlideMessage: 'Previous slide',
					nextSlideMessage: 'Next slide'
				}
			});
		}
	};

	return {
		init: initialize
	};
})();
crh.venue = (function() {
    'use strict';

    let initialize = () => {};

    return {
        init: initialize
    };
})();
crh.eventDetail = (function() {
    'use strict';

    let initialize = () => {
        $('.event-info a').click(function() {
            var href = $(this).attr('href');
            var positon = $(href).offset().top - 60;
            $('html, body').animate({
                scrollTop: positon
            });
            if (
                !$(href)
                    .next()
                    .hasClass('show')
            ) {
                $(href).click();
            }
        });

        //adjust font size for long titles
        var $heading = $('.page-header--event h1');
        var headingChars = $heading.text().split('').length;

        if (headingChars > 64) {
            $heading.addClass('long-heading');
        }
    };

    return {
        init: initialize
    };
})();
crh.formValidation = (function() {
    'use strict';

   // $.validator.methods.email = function(value, element) {
   //     return this.optional(element) || /[a-z]+@[a-z]+\.[a-z]+/.test(value);
   // };

    const validate = function($form, $successMsg) {
        $form.validate({
            debug: true,

            //email: true,

            errorClass: 'error-mes',
            highlight(element, errorClass, validClass) {
                const $element = $(element);

                console.log($element);
                // If first name + last name group
                $element
                    .closest('.form-group')
                    .addClass('error-state')
                    .removeClass(validClass);
            },
            unhighlight(element, errorClass, validClass) {
                const $element = $(element);
                if ($element.parent().hasClass('form-input')) {
                    $element
                        .parent()
                        .removeClass('error-state')
                        .closest('.form-group')
                        .removeClass('group-has-error');
                } else {
                    $element
                        .closest('.form-group')
                        .removeClass('error-state')
                        .addClass(validClass);
                }
            },
            errorPlacement(error, element) {
                const $element = $(element);
                error.insertAfter(element);
            },
            submitHandler(form) {
                const $form = $(form);
                const $formButton = $form.find('input[type="submit"]');

                if (grecaptcha.getResponse() == '') {
                    $('#reCaptchaError').html('<label class="error-mes">Please verify you are human</label>');
                } else if ($form.valid()) {
                    // prevent page from jumping if scroll is different
                    $formButton.addClass('form-submitting').attr('disabled', true);
                    form.submit();
                }
            }
        });
    };

    return {
        validate
    };
})();
crh.accessibility = (function() {
    'use strict';

    var filters = function() {
        $('#collapseDatesButton').on('keypress', function(e) {
            if (e.key === 'Enter') {
                $('pmu-today').focus();
            }
        });

        $('.pmu-button, .datepicker').on('keydown', function(e) {
            if (e.key === 'Escape') {
                $('#collapseDates').collapse('hide');
                $('.filter-buttons button:nth-child(2)').focus();
            }
        });

        $(document).ajaxComplete(function() {
            $('#collapseDatesButton').on('keypress', function(e) {
                if (e.key === 'Enter') {
                    $('pmu-today').focus();
                }
            });

            $('input.form-check-input, #collapseGenresButton').on('keydown', function(e) {
                if (e.key === 'Escape') {
                    $('#collapseGenres').removeClass('show');
                    $('#collapseGenresButton').attr('aria-expanded', 'false');
                }
            });
        });
    };

    var initialize = function() {
        if ($('body').hasClass('visit-page')) {
            $('.cta-package')
                .find('.btn')
                .attr('role', 'button')
                .attr('tabindex', '0');
        }
    };

    return {
        filters: filters,
        init: initialize
    };
})();
/**/